<template>
  <ModalBase :closeBtn="true" @closed="emit('closed')">
    <div class="modal-video" :class="{vertical: vertical}">
      <video controls autoplay>
        <source :src="`/static/video/${src}.mp4`" type="video/mp4" />
        <source :src="`/static/video/${src}.webm`" type="video/webm" />
        <source :src="`/static/video/${src}.ogv`" type="video/ogg" />
      </video>
      <IconLoader />
    </div>
  </ModalBase>
</template>

<script setup>
const props = defineProps(["src","vertical"]);
const emit = defineEmits(["closed"]);
</script>
